const formatKey = (newKey: string) => {
    newKey = newKey.replace(' ', '');
    newKey = newKey.replace(/[^A-Za-z0-9]/gi, '');
    return newKey;
}


export { formatKey };
